// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2LST2QfozD_LaXnw2RUKOc{background-color:#f5c531;height:.71429rem;display:flex;justify-content:space-around;align-items:center}._3a45irIwQzWw-mL2Pjwj32{height:4.71429rem}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bottomBar": "_2LST2QfozD_LaXnw2RUKOc",
	"bottomBar__content": "_3a45irIwQzWw-mL2Pjwj32"
};
export default ___CSS_LOADER_EXPORT___;
